export function readCurrentPlan(response, memberId) {
  const data = response?.data;
  if (
    !['00000', '0'].includes(String(response?.code)) ||
    String(data?.memberId) !== String(memberId) ||
    !['AVAILABLE', 'EMPTY'].includes(data?.status)
  )
    throw new Error('Invalid current plan response');
  if (data.status === 'EMPTY') return { status: 'EMPTY' };
  const text = (value, max, required = false) => {
    if (value == null && !required) return null;
    if (typeof value !== 'string' || value.length > max || !value.trim()) {
      throw new Error('Invalid current plan field');
    }
    return value;
  };
  const total = data.courseCount;
  const completed = data.completedCount;
  const progressAvailable =
    Number.isSafeInteger(total) &&
    total > 0 &&
    Number.isSafeInteger(completed) &&
    completed >= 0 &&
    completed <= total;
  return {
    status: data.status,
    currentPlanId:
      Number.isSafeInteger(data.currentPlanId) && data.currentPlanId > 0
        ? data.currentPlanId
        : null,
    name: text(data.planName, 200, true),
    source: text(data.source, 100),
    type: text(data.planType, 100),
    acquisition: text(data.acquisition, 100),
    target: text(data.target, 200),
    bodyParts: text(data.bodyParts, 200),
    difficulty: text(data.difficulty, 100),
    introduction: text(data.introduction, 10000),
    total: progressAvailable ? total : null,
    completed: progressAvailable ? completed : null,
  };
}

export function readPlanSchedule(response, query) {
  const data = response?.data;
  const text = (value, max) =>
    value == null || (typeof value === 'string' && value.length <= max);
  if (
    !['00000', '0'].includes(String(response?.code)) ||
    String(data?.memberId) !== String(query.memberId) ||
    data?.currentPlanId !== query.currentPlanId ||
    !Array.isArray(data.groups) ||
    data.groups.length > 100 ||
    !text(data.summary, 10000)
  )
    throw new Error('Invalid schedule');
  const sequences = new Set();
  data.groups.forEach((group) => {
    if (
      !group ||
      !text(group.title, 200) ||
      !text(group.courseRange, 100) ||
      !text(group.description, 3000) ||
      !text(group.status, 100) ||
      !Array.isArray(group.courses) ||
      group.courses.length > 100
    )
      throw new Error('Invalid group');
    group.courses.forEach((course) => {
      if (
        !course ||
        !Number.isSafeInteger(course.sequence) ||
        course.sequence <= 0 ||
        sequences.has(course.sequence) ||
        typeof course.name !== 'string' ||
        !course.name.trim() ||
        course.name.length > 200 ||
        !Number.isSafeInteger(course.courseIdent) ||
        course.courseIdent <= 0 ||
        !Number.isSafeInteger(course.courseType) ||
        course.courseType <= 0 ||
        (course.completed != null && typeof course.completed !== 'boolean') ||
        !text(course.date, 100) ||
        !text(course.week, 100) ||
        !text(course.instruments, 500) ||
        [course.estimateMinutes, course.actionCount].some(
          (value) =>
            value != null && (!Number.isSafeInteger(value) || value < 0),
        )
      )
        throw new Error('Invalid course');
      sequences.add(course.sequence);
      if (sequences.size > 100) throw new Error('Schedule exceeds budget');
    });
  });
  return data;
}
